import { render, staticRenderFns } from "./ItemRegistDialog.vue?vue&type=template&id=d1afaa2e&scoped=true&"
import script from "./ItemRegistDialog.vue?vue&type=script&lang=js&"
export * from "./ItemRegistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1afaa2e",
  null
  
)

export default component.exports